import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { useMusicVideoEditor } from '../MusicVideoEditorContext';
import { timelineMessages } from '../messages/timelineMessages';
import { pointerToSec, secToPercent, spanBox } from '../timeline/timelineGeometry';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from '../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The thin strip of the whole cut under the phone player (design f1); the line is the play head. A tap seeks. */
const MiniStripComponent: React.FC = () => {
  const intl = useIntl();
  const { doc, footage, transport } = useMusicVideoEditor();
  const view = { from: doc.settings.startSec, to: doc.settings.endSec };
  return (
    <div
      className={styles.phoneStrip}
      role="slider"
      tabIndex={0}
      aria-label={intl.formatMessage(timelineMessages.playHead)}
      aria-valuemin={view.from}
      aria-valuemax={view.to}
      aria-valuenow={transport.positionSec}
      onPointerDown={(event) =>
        transport.seek(pointerToSec(event.clientX, event.currentTarget.getBoundingClientRect(), view))
      }
      onKeyDown={(event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          transport.stepBar(event.key === 'ArrowLeft' ? -1 : 1);
        }
      }}
    >
      {doc.clips.map((clip) => {
        const box = spanBox(clip.startSec, clip.endSec, view);
        const poster = footage.lookup(clip.source)?.posterUrl ?? null;
        return box === null ? null : (
          <i
            key={clip.id}
            className={styles.phoneStripClip}
            style={{
              left: `${box.left}%`,
              width: `calc(${box.width}% - 1px)`,
              backgroundImage: poster === null ? undefined : `url("${poster}")`,
            }}
          />
        );
      })}
      <span className={styles.phoneStripHead} style={{ left: `${secToPercent(transport.positionSec, view)}%` }} />
    </div>
  );
};

export const MiniStrip = TypedMemo(MiniStripComponent);
